export default __webpack_public_path__ + "static/media/chrome.e6bcdd62.png";